/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Face_Card_DescInputs */

const vi_face_card_desc = /** @type {(inputs: Face_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký khuôn mặt của những người trong hộ hay đi giao chè`)
};

/**

* @param {Face_Card_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const face_card_desc = /** @type {((inputs?: Face_Card_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Face_Card_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_face_card_desc(inputs)
});